import React, { useState } from 'react';
import './Team.css';
import { useSectionView } from '../hooks/useSectionView';
import { sendEvent } from '../analytics';

const Team = () => {
  const [expandedCards, setExpandedCards] = useState({});

  const toggleCard = (cardId) => {
    setExpandedCards(prev => ({
      ...prev,
      [cardId]: !prev[cardId]
    }));
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const ScrollArrow = ({ targetSection, className }) => (
    <div 
      className={`scroll-arrow ${className || ''}`}
      onClick={() => { try { sendEvent('scroll_arrow_click', { target_section: (targetSection || '').replace('-section','') }); } catch (_) {} scrollToSection(targetSection); }}
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
          d="M7 10L12 15L17 10" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );

  return (
    <div id="team-section" className="team-section">
      {useSectionView('team', 'team-section')}
      <div className="team-header">
        <div className="team-badge">
          Ons Team
        </div>
        <div className="team-title">
          Wij werken aan waarde in Projecten
        </div>
        <div className="team-subtitle">
          Ontmoet ons ervaren professionals die helpen bij uw ruimtelijke vraagstukken.
        </div>
      </div>
      <div className="team-container">
        <div className="team-card">
          <div className="gradient-header">
            <div className="profile-avatar">
              <div className="avatar-circle">
                <img 
                  src="/erik-profile-zoom.jpg" 
                  alt="Erik de Bruin"
                  className="avatar-image"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <span className="avatar-initials" style={{display: 'none'}}>EB</span>
              </div>
            </div>
            <div className="profile-info">
              <div className="profile-name">Erik de Bruin</div>
              <div className="profile-title">Adviseur Planeconomie</div>
              <div className="profile-experience">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 1.5C6.61929 1.5 5.5 2.61929 5.5 4V5H4.5C3.94772 5 3.5 5.44772 3.5 6V13C3.5 13.5523 3.94772 14 4.5 14H11.5C12.0523 14 12.5 13.5523 12.5 13V6C12.5 5.44772 12.0523 5 11.5 5H10.5V4C10.5 2.61929 9.38071 1.5 8 1.5ZM9.5 5H6.5V4C6.5 3.17157 7.17157 2.5 8 2.5C8.82843 2.5 9.5 3.17157 9.5 4V5Z" fill="#FFFFFF"/>
                </svg>
                <span>15+ jaar ervaring</span>
              </div>
            </div>
          </div>
          <div className="card-content">
            <div className="profile-specialties">
              <div className="specialties-title">Specialisaties</div>
              <div className="specialty-tags">
                <span className="specialty-tag">Grondzaken, vastgoed</span>
                <span className="specialty-tag">Financiën</span>
                <span className="specialty-tag">Ruimtelijke ordening</span>
                <span className="specialty-tag">Risico management</span>
              </div>
            </div>
            <div className="profile-description">
              Ondernemend, vindingrijk en resultaatgericht zijn woorden die Erik goed omschrijven. Met deze eigenschappen heeft Erik voor diverse opdrachtgevers de afgelopen jaren op het gebied van grondzaken en gebiedseconomie met veel plezier mogen bijdragen aan diverse gebiedsontwikkelingen binnen Nederland. Vanuit verschillende rollen zoals adviseur planeconomie, projectleider, financieel expert, contractvormer, onderhandelaar, sparringpartner en coach heeft hij toegevoegde waarde kunnen bieden.
            </div>
            
            {expandedCards['erik'] && (
              <div className="expanded-content">
                <div className="skills-section">
                  <div className="section-header">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13 3L8 8L3 3" stroke="#3B82F6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M8 1V8" stroke="#3B82F6" strokeWidth="1.5" strokeLinecap="round"/>
                      <path d="M2 9H14V13C14 13.55 13.55 14 13 14H3C2.45 14 2 13.55 2 13V9Z" stroke="#3B82F6" strokeWidth="1.5" fill="none"/>
                      <circle cx="5" cy="11.5" r="0.5" fill="#3B82F6"/>
                      <circle cx="8" cy="11.5" r="0.5" fill="#3B82F6"/>
                      <circle cx="11" cy="11.5" r="0.5" fill="#3B82F6"/>
                    </svg>
                    <span>Vaardigheden</span>
                  </div>
                  <ul className="skills-list">
                    <li>Planeconomie</li>
                    <li>Grond- en vastgoedexploitaties</li>
                    <li>Publiek-private samenwerking</li>
                    <li>Wro, kostenverhaal(regels)</li>
                    <li>Organische gebiedsontwikkeling</li>
                    <li>Omgevingswet</li>
                    <li>Grondbeleid</li>
                    <li>Exploitatieplannen</li>
                    <li>Anterieure overeenkomsten</li>
                    <li>Grondwaardebepalingen</li>
                    <li>Erfpacht</li>
                    <li>Tenders</li>
                    <li>Grond- en vastgoedzaken algemeen</li>
                  </ul>
                </div>
                
                <div className="education-section">
                  <div className="section-header">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 1L15 4V12C15 12.55 14.55 13 14 13H2C1.45 13 1 12.55 1 12V4L8 1Z" stroke="#3B82F6" strokeWidth="1.5" fill="none"/>
                    </svg>
                    <span>Opleiding</span>
                  </div>
                  <ul className="education-list">
                    <li>Rijksuniversiteit Groningen, Bachelor Technische planologie</li>
                    <li>Urban studies, University of Washington</li>
                    <li>Masterclass in Planeconomie, Scobe Academy (post HBO/WO)</li>
                    <li>Nyenrode Business Universiteit, MBA Public&Private, module Public-Private Partnership</li>
                  </ul>
                </div>
                
                <div className="projects-section">
                  <div className="section-header">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 4H14V12H2V4Z" stroke="#3B82F6" strokeWidth="1.5" fill="none"/>
                      <path d="M6 2V4" stroke="#3B82F6" strokeWidth="1.5"/>
                      <path d="M10 2V4" stroke="#3B82F6" strokeWidth="1.5"/>
                    </svg>
                    <span>Recente Projecten</span>
                  </div>
                  <ul className="projects-list">
                    <li>Advies ontwikkelstrategie gebiedsontwikkeling Amstelveen</li>
                    <li>Coördinatie actualisatie MPG Amersfoort</li>
                  </ul>
                </div>
              </div>
            )}
            
            <div className="card-footer">
              <button 
                className="expand-button"
                onClick={() => toggleCard('erik')}
              >
                <span>{expandedCards['erik'] ? 'Sluit card' : 'Meer over Erik'}</span>
                <svg 
                  width="16" 
                  height="16" 
                  viewBox="0 0 16 16" 
                  fill="none" 
                  xmlns="http://www.w3.org/2000/svg"
                  className={expandedCards['erik'] ? 'rotated' : ''}
                >
                  <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div className="team-card">
          <div className="gradient-header">
            <div className="profile-avatar">
              <div className="avatar-circle">
                <img 
                  src="/ian-profile.jpg" 
                  alt="Ian van Hoof"
                  className="avatar-image"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <span className="avatar-initials" style={{display: 'none'}}>IH</span>
              </div>
            </div>
            <div className="profile-info">
              <div className="profile-name">Ian van Hoof</div>
              <div className="profile-title">Adviseur Planeconomie</div>
              <div className="profile-experience">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 1.5C6.61929 1.5 5.5 2.61929 5.5 4V5H4.5C3.94772 5 3.5 5.44772 3.5 6V13C3.5 13.5523 3.94772 14 4.5 14H11.5C12.0523 14 12.5 13.5523 12.5 13V6C12.5 5.44772 12.0523 5 11.5 5H10.5V4C10.5 2.61929 9.38071 1.5 8 1.5ZM9.5 5H6.5V4C6.5 3.17157 7.17157 2.5 8 2.5C8.82843 2.5 9.5 3.17157 9.5 4V5Z" fill="#FFFFFF"/>
                </svg>
                <span>15+ jaar ervaring</span>
              </div>
            </div>
          </div>
          <div className="card-content">
            <div className="profile-specialties">
              <div className="specialties-title">Specialisaties</div>
              <div className="specialty-tags">
                <span className="specialty-tag">Duurzame Economie</span>
                <span className="specialty-tag">Strategie</span>
                <span className="specialty-tag">Kennisdeling</span>
                <span className="specialty-tag">Data</span>
              </div>
            </div>
            <div className="profile-description">
              Ervaren in gebiedsontwikkeling en grootschalige publiek-private samenwerkingen. Ian werkt richtinggevend, kaderstellend en adviserend op strategisch niveau. Hij krijgt energie van het verbinden van ruimtelijke ambities, grondbeleid en financiële sturing. Op inhoudelijk vlak helpen zijn data-gedreven analyses in investeringsafwegingen en programmasturing. Ervaren sparringpartner voor management en bestuur.
            </div>
            
            {expandedCards['ian'] && (
              <div className="expanded-content">
                <div className="skills-section">
                  <div className="section-header">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13 3L8 8L3 3" stroke="#3B82F6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M8 1V8" stroke="#3B82F6" strokeWidth="1.5" strokeLinecap="round"/>
                      <path d="M2 9H14V13C14 13.55 13.55 14 13 14H3C2.45 14 2 13.55 2 13V9Z" stroke="#3B82F6" strokeWidth="1.5" fill="none"/>
                      <circle cx="5" cy="11.5" r="0.5" fill="#3B82F6"/>
                      <circle cx="8" cy="11.5" r="0.5" fill="#3B82F6"/>
                      <circle cx="11" cy="11.5" r="0.5" fill="#3B82F6"/>
                    </svg>
                    <span>Vaardigheden</span>
                  </div>
                  <ul className="skills-list">
                    <li>Planeconomie</li>
                    <li>Duurzame gebiedsontwikkeling</li>
                    <li>Financiële modellering</li>
                    <li>Circulaire economie</li>
                    <li>Energietransitie analyses</li>
                    <li>Economische haalbaarheid</li>
                    <li>Investeringsanalyses</li>
                    <li>Data-analyse en visualisatie</li>
                    <li>GIS en ruimtelijke analyse</li>
                    <li>Marktonderzoek</li>
                    <li>Bedrijfseconomie</li>
                    <li>Projectmanagement</li>
                    <li>Kostenbatenanalyses</li>
                  </ul>
                </div>
                
                <div className="education-section">
                  <div className="section-header">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 1L15 4V12C15 12.55 14.55 13 14 13H2C1.45 13 1 12.55 1 12V4L8 1Z" stroke="#3B82F6" strokeWidth="1.5" fill="none"/>
                    </svg>
                    <span>Opleiding</span>
                  </div>
                  <ul className="education-list">
                    <li>Universiteit van Amsterdam, Master Bedrijfseconomie</li>
                    <li>Universidad Autonoma Madrid, EU Erasmusprogramma</li>
                    <li>Masterclass in Planeconomie, Scobe Academy (post HBO/WO)</li>
                    <li>NY Coding & Design Academy, Opleiding data en software</li>
                  </ul>
                </div>
                
                <div className="projects-section">
                  <div className="section-header">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 4H14V12H2V4Z" stroke="#3B82F6" strokeWidth="1.5" fill="none"/>
                      <path d="M6 2V4" stroke="#3B82F6" strokeWidth="1.5"/>
                      <path d="M10 2V4" stroke="#3B82F6" strokeWidth="1.5"/>
                    </svg>
                    <span>Recente Projecten</span>
                  </div>
                  <ul className="projects-list">
                  <li>Adviseur planeconomie gemeente Amersfoort</li>
                  <li>Businesscase cultuurpodium</li>
                  </ul>
                </div>
              </div>
            )}
            
            <div className="card-footer">
              <button 
                className="expand-button"
                onClick={() => toggleCard('ian')}
              >
                <span>{expandedCards['ian'] ? 'Sluit card' : 'Meer over Ian'}</span>
                <svg 
                  width="16" 
                  height="16" 
                  viewBox="0 0 16 16" 
                  fill="none" 
                  xmlns="http://www.w3.org/2000/svg"
                  className={expandedCards['ian'] ? 'rotated' : ''}
                >
                  <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="team-footer">
        <button 
          className="team-cta-button"
          onClick={() => {
            const allExpanded = Object.keys(expandedCards).length > 0 && Object.values(expandedCards).every(value => value);
            if (allExpanded) {
              setExpandedCards({});
            } else {
              setExpandedCards({ erik: true, ian: true });
            }
          }}
        >
          <span>
            {Object.keys(expandedCards).length > 0 && Object.values(expandedCards).some(value => value) 
              ? 'Sluit alle cards' 
              : 'Meer over ons team'
            }
          </span>
          <svg 
            width="20" 
            height="20" 
            viewBox="0 0 20 20" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className={Object.values(expandedCards).some(value => value) ? 'rotated' : ''}
          >
            <path d="M6 8L10 12L14 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>
      <ScrollArrow targetSection="cta-section" className="team-arrow" />
    </div>
  );
};

export default Team;
